import { setAssetReferenceData } from './assetReference'

export const setCarouselAssetData = ({ postOption, parentPostOption }) => {
  if (parentPostOption) {
    return {
      ...setAssetReferenceData(parentPostOption.asset_reference),
      position: parentPostOption.position,
      // this is the only data we need from the child
      ctaUrl: postOption.value,
    }
  }

  return {
    ...setAssetReferenceData(postOption.asset_reference),
    position: postOption.position,
  }
}
